var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{ref:"zoom",attrs:{"src":_vm.image1,"data-zoom":_vm.image2,"alt":_vm.primary_alt,"data-zoom-alt":_vm.secondary_alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }